// extracted by mini-css-extract-plugin
export default {"container":"EJlCdZ","title":"PKAFbL mz-caption"};